export interface Package {
    id: string;
    name: string;
    transactions: number;
    price: number;
    icon: React.ElementType;
    features: string[];
}

/**
 * Enum for addon API keys as stored in the backend
 */
export enum AddonApiKey {
    DAILY_SYNC = 'Daily Sync',
    ADVANCED_ANALYTICS = 'Advanced Analytics',
    TAX_OPTIMIZATION = 'Tax Optimization',
    WE_DO_EVERYTHING = 'We Do Everything',
}

export interface Addons {
    expertReview: boolean;
    dailySync: boolean;
    portfolioInsights: boolean;
    taxOptimization: boolean;
    weDoEverything: boolean;
    individualSetup: boolean;
}

export interface TaxYearInfo {
    year: string;
    transactions: number;
    purchased?: boolean;
}

export interface CheckoutSessionRequest {
    selectedYears: Array<{
        taxYear: number;
        package:
            | {
                  id: string;
                  name: string;
                  price: number;
                  transactions: number;
              }
            | { id: string };
        expertReview: boolean;
    }>;
    addons: {
        dailySync: {
            enabled: boolean;
            currentValidUntil?: string;
        };
        portfolioInsights: {
            enabled: boolean;
            currentValidUntil?: string;
        };
        taxOptimization: {
            enabled: boolean;
            currentValidUntil?: string;
        };
        weDoEverything: {
            enabled: boolean;
            customPricing?: {
                price: number;
                currency: string;
            };
            isCustomPricing?: boolean;
        };
    };
    source?: string;
}

export interface CheckoutSessionResponse {
    id: string;
    url: string;
}

// Firestore timestamp type definition
export interface FirestoreTimestamp {
    _seconds: number;
    _nanoseconds: number;
}

export interface TaxReport {
    package: string;
    transactionLimit: number;
    purchaseDate: string | FirestoreTimestamp;
    stripePaymentId: string;
    status: 'active' | 'refunded';
}

export interface ExpertReview {
    status: 'active' | 'refunded';
    stripePaymentId: string;
    purchaseDate: string | FirestoreTimestamp;
}

export interface Addon {
    validUntil: string | FirestoreTimestamp;
    stripePaymentId: string;
    status: 'active' | 'refunded';
    validated?: boolean;
}

export interface UserPlans {
    [key: string]: any; // Allow any key-value pairs
    stripeCustomerId?: string;
    createdAt?: string;
    updatedAt?: string;
}
